import React from "react";

export default function NoRule() {
  return (
    <div _ngcontent-ng-c841324608="" style={{ backgroundColor: "white" }}>
      <div _ngcontent-ng-c841324608="" className="card card-body">
        <div
          _ngcontent-ng-c841324608=""
          id="rulesList___BV_modal_body_"
          className="modal-body"
        >
          <div _ngcontent-ng-c841324608="" id="rulesBoxContainer">
            <div style={{ width: "100%" }}>
              <span style={{ textAlign: "center" }}>
                No Rules Found!
                <span />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
